<ifc-app-scroll-container class="ifc-app-scroll-container-center">
    <div id="main" fxLayout="column" fxLayoutAlign="center center">

        <div fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="48px" fxFlexFill.lt-lg
             ngClass.lt-lg="fit-content">

            <div class="layout padding-horizontal align-center">
                <span class="title">How much would you like to draw today?</span>
            </div>

            <div fxLayout.gt-md="row" fxLayoutAlign.gt-md="start start" fxLayoutGap.gt-md="48px" fxLayout="column"
                 fxLayoutAlign="start center">

                <form [formGroup]="form">

                    <div fxLayout="column" fxLayoutAlign="start start" fxLayoutAlign.lt-md="start center"
                         fxLayoutGap="24px">
                        <div [ngClass.xl]="'form-field-lg'"
                             [ngClass.gt-xs]="'form-field-md'"
                             [ngClass.xs]="'form-field-xs'"
                             *ngIf="data?.productCode !== ProductCode.Law">
                            <button mat-stroked-button type="button"
                                    [ngClass]="{'selected': form.controls.drawAmount.value === data?.amountMaximum}"
                                    (click)="setAmount(data?.amountMaximum)">
                                <span class="color-primary">{{ data?.amountMaximum | currency:'$' }}</span>
                            </button>
                            <div class="mat-caption sub-title">Maximum amount</div>
                        </div>
                        <div [ngClass.xl]="'form-field-lg'"
                             [ngClass.gt-xs]="'form-field-md'"
                             [ngClass.xs]="'form-field-xs'"
                             *ngIf="data?.productCode !== ProductCode.Law">
                            <button mat-stroked-button type="button"
                                    [ngClass]="{'selected': form.controls.drawAmount.value === data?.suggestedDrawAmount}"
                                    (click)="setAmount(data?.suggestedDrawAmount)">
                                <span class="color-primary">{{ data?.suggestedDrawAmount | currency:'$' }}</span>
                            </button>
                            <div class="mat-caption sub-title">Suggested amount</div>
                        </div>
                        <div [ngClass.xl]="'form-field-lg'"
                             [ngClass.gt-xs]="'form-field-md'"
                             [ngClass.xs]="'form-field-xs'">
                            <mat-form-field appearance="outline" id="otherAmount">
                                <mat-label>Other amount</mat-label>
                                <input matInput autocomplete="off" placeholder="Other amount" currencyMask
                                       formControlName="drawAmount">
                                <mat-hint>Amount
                                    between {{ data?.amountMinimum | currency:'$' }}
                                    and {{ data?.amountMaximum | currency:'$' }}
                                </mat-hint>
                                <mat-error>
                                    Enter an amount between {{ data?.amountMinimum | currency:'$' }} and
                                    {{ data?.amountMaximum | currency:'$' }}
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <ifc-promo-code [data]="data.accountTransferData"
                                        (promotionApplied)="applyPromotionChanged($event)"></ifc-promo-code>
                    </div>
                </form>

                <ifc-transaction-details [data]="data.accountTransferData"></ifc-transaction-details>

            </div>
        </div>
    </div>
</ifc-app-scroll-container>
